import { useState, useMemo, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Modal } from "reactstrap";
import {
  EmbedIcon,
  facebookIcon,
  instagramIcon,
  twitterIcon,
  crossIcon,
  homeIcon,
} from "../../../Shared/SVGs/Shared";
import FormStepsModal from "./FormStepsModal";
import { useSelector, useDispatch } from "react-redux";
import { updateCampaignFields, updateCampaignState } from "../CampaignActions";
import { FacebookShareButton, TwitterShareButton } from "react-share";
import {
  updateCampaignState as videoUpdateCampaignState,
  updateParams,
  updateVideoPageState,
} from "../../Video/VideoActions";

const content = (
  <div className="mb-3">
    Share your campaign easily by{" "}
    <b style={{ color: "black" }}>copying the link</b> or clicking{" "}
    <b style={{ color: "black" }}>'Generate QR Code'</b> to create and download
    a unique QR code. This code will be prominently displayed on your campaign
    page, allowing anyone to scan and effortlessly upload their video to
    participate in your campaign.
  </div>
);

const FormStep4QRModal = ({ open, toggle }) => {
  const activeStep = useSelector((state) => state.campaign_states.activeStep);
  const campaign_response = useSelector(
    (state) => state.campaign_states.campaign_response
  );
  const [copied, setCopied] = useState(false);
  const form = useSelector((state) => state.campaign_states.form);
  const campaignUrl = `${process.env.REACT_APP_CAMPAGIN_URL}/form/${campaign_response?._id}/landing`;

  const componentRef = useRef();
  const navigate = useNavigate();

  const dispatch = useDispatch();

  const activeCampaign = (state) => {
    dispatch(
      updateCampaignFields({
        banner_share_url: "",
        banner_with_qr: "",
      })
    );
    navigate("/videos/campaigns");
    // dispatch(
    //   updateParams({
    //     tab: "Campaigns",
    //     transcriptView: false,
    //     is_widget: false,
    //     search: "",
    //     page: 1,
    //     isTrashTab: false,
    //     isFlaggedTab: false,
    //     isFavoriteTab: false,
    //     isCampaignTab: true,
    //     updateParamsOnly: true,
    //   })
    // );
    // dispatch(
    //   updateVideoPageState({
    //     isCategoryPage: false,
    //     isCampaignListPage: true,
    //   })
    // ); 
    dispatch(videoUpdateCampaignState({ tab: "ACTIVE" }));
  };

  const handleCopyClick = () => {
    setCopied(!copied);
    const linkElement = document.getElementById("campaign-link");
    if (linkElement) {
      const linkText = linkElement.textContent;
      const tempInput = document.createElement("input");
      document.body.appendChild(tempInput);
      tempInput.value = linkText;
      tempInput.select();
      document.execCommand("copy");
      document.body.removeChild(tempInput);
    }
  };
  // const closeModal = () => {
  //   toggle;
  // };

  // console.log(campaign_response);
  const step4Content = (
    <>
      {" "}
      {activeStep === 4 && (
        <>
          <div className="d-flex justify-content-center mt-2">
            <img
              src={
                require(`@src/assets/images/vyrill/campaign-tool/qrimage.png`)
                  .default
              }
              alt=""
              width={229}
            />
          </div>
          <div
            className="generate-qr d-flex justify-content-center mt-1"
            onClick={() =>
              dispatch(updateCampaignState({ activeStep: activeStep + 1 }))
            }
          >
            Generate QR Code
          </div>
        </>
      )}
    </>
  );

  const handleCopyEmbed = () => {
    const iframeHTML = `<iframe src='${form?.banner_share_url}' style='width: 765px; height: 721px;'></iframe>`;
    navigator.clipboard.writeText(iframeHTML);
    alert("Embed code copied successfully");
  };

  const step5Content = (
    <>
      {activeStep === 5 && (
        <>
          <div className="share-icons">
            <div onClick={handleCopyEmbed}>
              {EmbedIcon} <div className="icon-text">Embed</div>{" "}
            </div>
            <div>
              <FacebookShareButton
                // url={campaign_response?.banner_url}
                url={form?.banner_share_url}
                quote={campaign_response?.name}
                // hashtag="#example"
                media={campaign_response?.banner_url}
              >
                {facebookIcon}
                <div className="icon-text">Facebook</div>
              </FacebookShareButton>
            </div>

            {/* <div
              onClick={() => window.open("https://www.instagram.com", "_blank")}
            >
              {instagramIcon} <div className="icon-text">Instagram</div>{" "}
            </div> */}
            <div
            // onClick={() => window.open("https://www.twitter.com", "_blank")}
            >
              <TwitterShareButton
                title={campaign_response?.name}
                url={campaignUrl}
                // hashtags={["hashtag1", "hashtag2"]}
              >
                <div className="custom-icon"> {twitterIcon}</div>{" "}
                <div className="icon-text">X</div>{" "}
              </TwitterShareButton>
            </div>
          </div>
        </>
      )}
    </>
  );

  return (
    <>
      {open && <div className="backdrop"></div>}
      <Modal
        isOpen={open}
        toggle={toggle}
        contentClassName="qr-code-modal"
        backdrop={false}
      >
        {activeStep === 4 && (
          <FormStepsModal
            step={4}
            content={content}
            style={{ position: "relative", top: "293px", left: "70px" }}
          />
        )}
        {activeStep === 5 ? (
          <div className="share d-flex justify-content-between ms-3 mt-4">
            Share
            <span
              onClick={toggle}
              style={{ cursor: "pointer", marginRight: "20px" }}
            >
              {crossIcon}
            </span>
          </div>
        ) : (
          <div className="live-campaign mt-5">Your campaign is live now!</div>
        )}
        {/* step 4 content */}
        {step4Content}

        {/* step 4 content */}
        {form?.banner_share_url && step5Content}
        <div
          className={`d-flex justify-content-center ${
            activeStep === 5 ? " mt-4" : "mt-2"
          }`}
        >
          <div className="campaign-link-div mt-1">
            <div className="campaign-link me-auto" id="campaign-link">
              {campaignUrl}
            </div>
            <div className="copy-icon" onClick={handleCopyClick}>
              {copied ? "Copied" : "COPY"}
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-center align-item-center mt-3">
          {/* <div>{homeIcon}</div> */}
          <div className="text-home" onClick={activeCampaign} role="button">
            See Active Campaign
          </div>
        </div>
      </Modal>
    </>
  );
};

export default FormStep4QRModal;
